"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useUncontrolled = function useUncontrolled(value, defaultValue, onChange) {
  var isControlled = (0, _react.useMemo)(function () {
    return value !== undefined;
  }, [value]);

  var _useState = (0, _react.useState)(function () {
    return isControlled ? value : defaultValue;
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      v = _useState2[0],
      setV = _useState2[1];

  var finalValue = isControlled ? value : v;
  var o = (0, _react.useCallback)(function (v) {
    if (!isControlled) setV(v);
    onChange === null || onChange === void 0 ? void 0 : onChange(v);
  }, [onChange, isControlled]);
  return [finalValue, o];
};

var _default = useUncontrolled;
exports.default = _default;